{ Jadelet } from @danielx/dui

// The actions-bar MIDI cluster is just the record toggle now — the device
// selector moved into the mode modal (views/mode-modal.civet) with the rest
// of the performance configuration.
Template := Jadelet.exec """
  aside.midi-input.control-group(class=@hiddenUnlessPurchased)
    button(click=@toggleRecord class=@recordingClass title="Record MIDI Input") ⬤
"""

export MidiInput := (player: Player) ->

  self :=
    hiddenUnlessPurchased: player.hiddenUnlessPurchased

    toggleRecord: ->
      player.recordingMidiInput.toggle()
    recordingClass: ->
      "active" if player.recordingMidiInput()
    element: null as! HTMLElement

  self.element = Template self

  return self

export default MidiInput
